module.exports = __webpack_public_path__ + "img/KinokoTable10.c790fc2e.jpg";